<script setup lang="ts">
import CabHeader from '@/views/header/CabHeader.vue';
import CabLink from '@/views/header/CabLink.vue';
import {numHedenReady, numHedenTodo} from '@/base/reporter.js';
import {stateForReporters, fetchAndSetState, startStatePolling, stopStatePolling} from '@/base/TMP_globalState.js';
import {AvailabilityState} from 'common';
import {computed, onMounted, onUnmounted} from 'vue';
import {done, loadingState, reload} from '@/base/loadingState.js';
import LoadingStateView from '@/views/general/LoadingStateView.vue';
import {RouterView, useRoute} from 'vue-router';

const route = useRoute();
// the dashboard is available while the site is closed for reporting, so it must not be hidden behind the closed check below
const onDashboard = computed<boolean>(() => route.path.startsWith('/report/dashboard'));

onMounted(async () => {
    await reload();
    await fetchAndSetState();
    startStatePolling();
});

onUnmounted(() => {
    stopStatePolling();
});
</script>

<template>
    <div class="h-screen relative">
        <CabHeader>
            <template v-if="stateForReporters!==AvailabilityState.closed">
                <CabLink name="rapporteren"
                         to="/report/rapporteren"
                         :badge-value="numHedenReady"
                         badge-color="green"
                         :badge-extra-value="numHedenTodo"
                         badge-extra-color="orange"
                />
                <CabLink name="al mijn KPIs"
                         to="/report/al-mijn-kpis"
                />
                <CabLink name="beheer"
                         to="/report/beheer"
                />
            </template>
            <CabLink name="dashboard"
                     to="/report/dashboard"
                     :exact="false"
            />
        </CabHeader>
        <LoadingStateView :state="loadingState" :stateForReporters="onDashboard ? AvailabilityState.read : stateForReporters"/>
        <RouterView v-if="done && (stateForReporters!==AvailabilityState.closed || onDashboard)"/>
    </div>
</template>
